import { createApp } from 'vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/ru'
import App from './App.vue'
import router from './router'
import './style/main.css'

// Настройка dayjs для начала недели с понедельника
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/ru'

dayjs.extend(updateLocale)
dayjs.updateLocale('ru', { weekStart: 1 })
dayjs.locale('ru')

// User utilities (from f1e/js/user-utils.js)
window.userDisplay = function() {
  if (window.current_user && window.current_user.login) {
    return window.current_user.login
  }
  return window.USER_EMAIL || ''
}

window.userInitials = function() {
  const name = window.userDisplay()
  if (!name) return '?'
  const parts = name.split(/[\s@._-]+/)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase()
  }
  return name.substring(0, 2).toUpperCase()
}

window.logout = async function() {
  try {
    await fetch('/api/logout', { method: 'GET' })
    window.location.href = '/login'
  } catch (e) {
    console.error(e)
  }
}

if (!window.is_user_in_role) {
  window.is_user_in_role = function(role) {
    return window.USER_ROLES && window.USER_ROLES.includes(role)
  }
}

const app = createApp(App)

app.use(router)
app.use(ElementPlus, { locale })

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')